import type { CountSessionStatus } from '@/api/endpoints/inventory-count-sessions'

/** Badge variant per session status, shared by the history list and the detail header. */
export const COUNT_SESSION_STATUS_VARIANT: Record<
  CountSessionStatus,
  'default' | 'secondary' | 'destructive'
> = {
  OPEN: 'default',
  CLOSED: 'secondary',
  EXPIRED: 'destructive',
  ABORTED: 'destructive',
}
